import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SMS_CREDIT_PACKAGE } from "../../../Routing/routes";
import SmsCreditPackageListLayer from "./Component/SmsCreditPackageListLayer";

const SmsCreditPackage = () => {
    const links = [{ to: SMS_CREDIT_PACKAGE, text: 'SMS Credit Package' }];

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description='View and manage SMS credit packages'
                links={links}
                headingTitle="SMS Credit Package"
            />
            <SmsCreditPackageListLayer />
        </>
    );
};

export default SmsCreditPackage;
